<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-form</h2>
            <p class="demo-description">New product creation form — demonstrates <code>upp-form</code> sections, actions, warnings, button bar, and buttons.</p>

            <div class="demo-controls">
    <ion-button size="small" (click)="toggleSectionFill()">Section Fill: {{ sectionFill }}</ion-button>
    <ion-button size="small" (click)="toggleWarning()">Warning: {{ showWarning }}</ion-button>
    <ion-button size="small" (click)="toggleButtonFloat()">Button Float: {{ buttonFloat }}</ion-button>
</div>

<div class="demo-section">
    <h3>New Product</h3>

    <upp-form [formGroup]="form">

        <!-- Basic info -->
        <upp-form-section title="Basic Info" icon="pricetag-outline" [fill]="sectionFill">
            <ion-item>
                <upp-input
                    formControlName="name"
                    placeholder="e.g. Café con leche"
                    title="Product Name"
                    [readonly]="false"
                    [kiosk]="false">
                </upp-input>
            </ion-item>

            <ion-item>
                <upp-input
                    formControlName="price"
                    placeholder="0.00"
                    title="Price"
                    type="price"
                    [readonly]="false"
                    [kiosk]="false">
                </upp-input>
            </ion-item>
        </upp-form-section>

        <!-- Separator -->
        <upp-form-action title="Details" icon="information-circle-outline"></upp-form-action>

        <!-- Description -->
        <upp-form-section title="Details" [fill]="sectionFill">
            <ion-item>
                <upp-textarea
                    formControlName="description"
                    placeholder="Describe the product..."
                    title="Description"
                    [rows]="3"
                    [readonly]="false"
                    [kiosk]="false">
                </upp-textarea>
            </ion-item>
        </upp-form-section>

        <!-- Warning -->
        <upp-form-warning
            *ngIf="showWarning"
            title="Price is below cost"
            subtitle="Review the price before publishing."
            icon="warning-outline"
            [lines]="warningLines">
        </upp-form-warning>

        <!-- Action bar -->
        <upp-form-buttonbar>
            <upp-form-barbutton [active]="true">
                <ion-button size="small" color="tertiary" (click)="onPreview()">
                    <ion-icon name="eye-outline" slot="start"></ion-icon>
                    Preview
                </ion-button>
            </upp-form-barbutton>
            <upp-form-barbutton [active]="true">
                <ion-button size="small" color="success" (click)="onPublish()">
                    <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
                    Publish
                </ion-button>
            </upp-form-barbutton>
        </upp-form-buttonbar>

        <!-- Main buttons -->
        <upp-form-buttons [float]="buttonFloat">
            <ion-button color="primary" (click)="onSave()">
                <ion-icon name="save-outline" slot="start"></ion-icon>
                Save
            </ion-button>
            <ion-button color="medium" (click)="onCancel()">
                <ion-icon name="close-outline" slot="start"></ion-icon>
                Cancel
            </ion-button>
        </upp-form-buttons>
    </upp-form>
</div>
        </div>
    </upp-scrollable>
</div>
